module.exports = __webpack_public_path__ + "static/media/970-x-300.c227e7db.png";